import { handleActions, createAction } from 'redux-actions';
import { cloneDeep } from 'lodash';
import { ACCEPTED, SOLD } from '../consts/navigation';

// Completed
export const FETCH_ARCHIVE_ACCEPTED = createAction('FETCH/ARCHIVE/ACCEPTED');
export const FETCH_ARCHIVE_ACCEPTED_SUCCESS = createAction('FETCH/ARCHIVE/ACCEPTED/SUCCESS');
export const FETCH_ARCHIVE_ACCEPTED_FAIL = createAction('FETCH/ARCHIVE/ACCEPTED/FAIL');
// Rejected
export const FETCH_ARCHIVE_SOLD = createAction('FETCH_ARCHIVE_SOLD');
export const FETCH_ARCHIVE_SOLD_SUCCESS = createAction('FETCH_ARCHIVE_SOLD_SUCCESS');
export const FETCH_ARCHIVE_SOLD_FAIL = createAction('FETCH_ARCHIVE_SOLD_FAIL');

const initialState = {
  [ACCEPTED]: {
    data: [],
    errors: null,
    total_count: null,
    total_pages: null,
  },
  [SOLD]: {
    data: [],
    errors: null,
    total_count: null,
    total_pages: null,
  },
};

const archiveTablesReducer = handleActions(
  {
    [FETCH_ARCHIVE_ACCEPTED_SUCCESS]: (state, { payload: { offers, total_count, total_pages, }, }) => {
      const newState = cloneDeep(state);
      newState[ACCEPTED].data = offers;
      newState[ACCEPTED].total_count = total_count;
      newState[ACCEPTED].total_pages = total_pages;
      return newState;
    },
    [FETCH_ARCHIVE_ACCEPTED_FAIL]: (state, { payload: { error, }, }) => {
      const newState = cloneDeep(state);
      newState[ACCEPTED].errors = error;
      return newState;
    },
    [FETCH_ARCHIVE_SOLD_SUCCESS]: (state, { payload: { offers, total_count, total_pages, }, }) => {
      const newState = cloneDeep(state);
      newState[SOLD].data = offers;
      newState[SOLD].total_count = total_count;
      newState[SOLD].total_pages = total_pages;
      return newState;
    },
    [FETCH_ARCHIVE_SOLD_FAIL]: (state, { payload: { error, }, }) => {
      const newState = cloneDeep(state);
      newState[SOLD].errors = error;
      return newState;
    },
  },
  initialState
);

export default archiveTablesReducer;
